export default "__VITE_ASSET__78022a9b__"